import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const productsInBasketAdapter = createEntityAdapter({
  selectId: (product) => product._id,
});

const initialState = {
  ui: {
    loading: false,
    adding_product: false,
    stats: {
      pageCount: 1,
    },
  },
  data: [],
  basket: productsInBasketAdapter.getInitialState(),
};

export const productsReducerSlice = createSlice({
  name: 'products',
  initialState,

  reducers: {
    get_products_success: (state, { payload }) => {
      state.ui.loading = false;
      const { products, stats } = payload;
      state.data = products;
      state.ui.stats = {
        ...stats,
      };
    },
    get_search: (state) => {
      state.ui.loading = true;
    },
    get_products_search_success: (state, { payload }) => {
      state.ui.loading = false;
      const { products, stats } = payload;
      state.data = products;
      state.ui.stats = {
        ...stats,
      };
    },
    get_products_error: (state) => {
      state.ui.loading = false;
    },
    get_products: (state) => {
      state.ui.loading = true;
    },
    add_product_to_basket: (state) => {
      state.ui.adding_product = true;
    },
    add_product_to_basket_error: (state) => {
      state.ui.adding_product = false;
    },
    add_product_to_basket_success: (state, { payload }) => {
      productsInBasketAdapter.upsertOne(state.basket, payload);
      state.ui.adding_product = false;
    },
  },
});

export const {
  get_products_success,
  get_products_error,
  get_products,
  add_product_to_basket,
  add_product_to_basket_error,
  add_product_to_basket_success,
  get_search,
  get_products_search_success,
} = productsReducerSlice.actions;

export default productsReducerSlice.reducer;
